import { TagDesignTokens } from '@primeuix/themes/types/tag';

import {
  getFontWeight,
  getRem,
} from '@customer-portal/shared/helpers/theme-utils';

export const tagOverride: TagDesignTokens = {
  root: {
    borderRadius: getRem(10),
    fontSize: getRem(9),
    fontWeight: getFontWeight('bold'),
    roundedBorderRadius: getRem(16),
    padding: '0',
  },
  colorScheme: {
    light: {
      primary: {
        background: 'transparent',
      },
    },
  },
};
